export const dashboardConstants = {
    errors: {
        fetchFailed: "Failed to load dashboard.",
        healthScoreFailed: "Failed to load health score.",
        metricsFailed: "Failed to load metrics.",
        genericError: "Something went wrong.",
    },
};
